var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGswmMarkerNotUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-30%",
    y: "-20%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 2.5,
    floodColor: "#0F172A",
    floodOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fill",
    x1: 8,
    y1: 5,
    x2: 31,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94A3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475569"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 45C18.2 41.7 7 31.6 7 20C7 12.8 12.8 7 20 7C27.2 7 33 12.8 33 20C33 31.6 21.8 41.7 20 45Z",
    fill: "url(#fill)",
    stroke: "white",
    strokeWidth: 3,
    filter: "url(#shadow)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 8.5,
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 20H24.2",
    stroke: "#64748B",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGswmMarkerNotUse);
export default __webpack_public_path__ + "static/media/gswm-marker-not-use.a811222d77fdb76a5024bb434ed645c8.svg";
export { ForwardRef as ReactComponent };